import React from "react";

import { siteLocationPrefix } from "../../constants";
import { Programs } from "../../models/programsConfig";
import { TestButton } from "./TestButton";
import { TestInput } from "./TestInput";
import * as styles from "./TestStyle.module.css";

export const TestPCEnrollmentActions = () => (
  <div className={styles.pcEnrollmentActionsWrapper}>
    <h3>Partner Center Enrollment Actions</h3>
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setPartnerCenterTokenOverride`}
      label="Set Partner Center token override ('delete' to remove) "
      buttonText="set"
      actionName="tokenOverride"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=Enabled`}
      title="Set Enrollment Status to Enable"
    />

    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=EarlyInProgress`}
      title="Set Enrollment Status to EarlyInProgress"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=InProgress`}
      title="Set Enrollment Status to InProgress"
    />

    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=EarlyRejected`}
      title="Set Enrollment Status to EarlyRejected"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=Rejected`}
      title="Set Enrollment Status to Rejected"
    />

    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=EarlyComplete`}
      title="Set Enrollment Status to EarlyComplete"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=Complete`}
      title="Set Enrollment Status to Complete"
    />

    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/setEnrollmentStatus?status=Unset`}
      title="Set Enrollment Status to Unset"
    />
    <TestInput
      actionURL={`${siteLocationPrefix}/test/setReferenceId`}
      label="Set Reference Id ('delete' to remove) "
      buttonText="set"
      actionName="referenceId"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/generateToken`}
      title="Generate a Token"
    />
    <TestButton
      type={Programs.IdXbox}
      url={`${siteLocationPrefix}/test/removeTokenFromRedis`}
      title="Remove PC Token from Redis"
    />
    <br />
    <br />
  </div>
);
